<template :style="background-color: this.myStyle">
  <div id="app">
    <Video videoSource="TACET" class="video-container" v-if="videoIsPlaying"/>
    <Navbar v-if="renderMainPage" style="padding: 0px; margin: 0px" @emitActiveValue="this.active = $event"/>
    <div id="components" v-if="renderAll">
      <transition name="slide-fade">
        <About v-if="active == 'About TACET'"/>
        <VR v-if="active == 'VR Environment'"/>
        <Eyetracking v-if="active == 'Innovation in Eyetracking'"/>
      </transition>
    </div>
  </div>
</template>

<script>
import {bus} from './main'
import Navbar from './components/Navbar.vue'
import Video from './components/Video.vue'
import About from './components/About.vue'
import VR from './components/VR.vue'
import Eyetracking from './components/Eyetracking.vue'

export default {
  name: 'App',
  components: {
    Navbar,
    Video,
    About,
    VR,
    Eyetracking
  },
  methods: {
    getWindowHeight() {
      return window.innerHeight;
    },
    getWindowWidth() {
      return window.innerWidth;
    },
    timeoutVideo() {
      this.videoIsPlaying = false
      console.log("Variable updated.")
      this.renderAllElements()
    },
    renderAllElements() {
      this.renderMainPage = true
      this.renderAll = true
      console.log("Page rendered.")
    }
  },
  data(){
    return {
      myStyle: "#003552",
      videoIsPlaying: true,
      renderMainPage: false,
      renderAll: false,
      active: 'About TACET'
    }
  },
  mounted: function() {
    setTimeout(this.timeoutVideo, 4200)
    setTimeout(this.renderAllElements, 4500)
  },
  created() {
     bus.$on('updateActiveValue', (data) => {
        this.active = data;
         console.log(data)
      })
  },
  watch: {
    active: function(active) {
      bus.$on('updateActiveValue', active => {
        this.active = active;
      })
      console.log(active)
    }
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 0px;
}

.video-container {
  position: absolute;
  top: 0;
  bottom: 0;
  width: 100%;
  height: 100%; 
  overflow: hidden;
}
.video-container video {
  /* Make video to at least 100% wide and tall */

  /* Setting width & height to auto prevents the browser from stretching or squishing the video */

  /* Center the video */
  position: absolute;
  top: 0%;
  left: 0%;
  /*transform: translate(-50%,-50%);*/
}

.slide-fade-enter-active {
  transition: all .3s ease;
}
.slide-fade-leave-active {
  transition: all .8s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateX(10px);
  opacity: 0;
}
</style>
